import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

const ScrollToTop: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            // Calculate total scrollable height
            const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
            const currentScroll = window.scrollY;

            // Calculate progress percentage
            const progress = totalHeight > 0 ? (currentScroll / totalHeight) * 100 : 0;
            setScrollProgress(progress);

            // Show button after scrolling down 100px
            if (currentScroll > 100) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    // SVG Circle configuration
    const radius = 20;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference - (scrollProgress / 100) * circumference;

    return (
        <div
            className={`fixed bottom-8 right-8 z-50 transition-all duration-300 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
                }`}
        >
            <button
                onClick={scrollToTop}
                className="relative w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:shadow-xl transition-shadow group"
                aria-label="Scroll to top"
            >
                {/* Progress Circle Background */}
                <svg className="absolute top-0 left-0 w-full h-full -rotate-90 transform" viewBox="0 0 48 48">
                    <circle
                        cx="24"
                        cy="24"
                        r={radius}
                        className="stroke-gray-200 fill-none"
                        strokeWidth="3"
                    />
                    <circle
                        cx="24"
                        cy="24"
                        r={radius}
                        className="stroke-brand-blue fill-none transition-all duration-100 ease-out"
                        strokeWidth="3"
                        strokeDasharray={circumference}
                        strokeDashoffset={strokeDashoffset}
                        strokeLinecap="round"
                    />
                </svg>

                {/* Arrow Icon */}
                <ArrowUp
                    size={20}
                    className="text-brand-blue group-hover:-translate-y-1 transition-transform duration-300"
                />
            </button>
        </div>
    );
};

export default ScrollToTop;
